import { render, staticRenderFns } from "./newDetails.vue?vue&type=template&id=6b52e0aa&scoped=true&"
import script from "./newDetails.vue?vue&type=script&lang=js&"
export * from "./newDetails.vue?vue&type=script&lang=js&"
import style0 from "./newDetails.vue?vue&type=style&index=0&id=6b52e0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52e0aa",
  null
  
)

export default component.exports